import { Loader } from '@googlemaps/js-api-loader';

(function ($) {
  $(document).ready(() => {
    const container = document.getElementById('event-map');
    if (container) {
      $.fn.textWidth = function () {
        const self = $(this);
        const children = self.children();
        const calculator = $('<span style="display: inline-block;">');
        children.wrap(calculator);

        const width = children.parent().width();
        children.unwrap();

        return width;
      };

      const loader = new Loader({
        /* global gmap:readonly */
        apiKey: gmap.google_key,
        version: 'weekly',
        language: gmap.map_lang
      });

      loader.load().then(async () => {
        const markerData = JSON.parse(
          container.getAttribute('data-markers') || '[]'
        );
        const { LatLng, event, Point, LatLngBounds } =
          await google.maps.importLibrary('core');
        const { Map, MapTypeId } = await google.maps.importLibrary('maps');
        const { Marker } = await google.maps.importLibrary('marker');

        let markerZIndex = 9999;
        const locationName = [];
        const address = [];
        const coordinates = [];
        const markers = [];
        const markersLength = markerData.length;

        for (let i = 0; i < markersLength; i++) {
          coordinates[i] = new LatLng(
            markerData[i].latitude,
            markerData[i].longitude
          );
          locationName[i] = '<strong>' + markerData[i].name + '</strong>';
          address[i] = markerData[i].address;
          address[i] =
            address[i] +
            (markerData[i].city !== ''
              ? (address[i] !== '' ? ', ' : '') + markerData[i].city
              : '');
          address[i] =
            address[i] +
            (markerData[i].zip !== ''
              ? (address[i] !== '' ? ', ' : '') + markerData[i].zip
              : '');
          address[i] = '<span>' + address[i] + '</span>';
        }

        const map = new Map(document.getElementById('event-map'), {
          disableDoubleClickZoom: false,
          center: coordinates[0],
          draggable: true,
          keyboardShortcuts: true,
          scrollwheel: true,
          zoom: 15,
          mapTypeId: MapTypeId.ROADMAP,
          zoomControl: true,
          mapTypeControl: true,
          streetViewControl: true,
          overviewMapControl: false,
          panControl: false,
          rotateControl: false,
          scaleControl: false
        });

        event.addListener(map, 'dragstart', () => {
          $('.location-tooltip').fadeOut(300);
        });

        event.addListener(map, 'click', () => {
          $('.location-tooltip').fadeOut(300);
        });

        event.addListener(map, 'zoom_changed', () => {
          $('.location-tooltip').fadeOut(300);
        });

        for (let i = 0; i < markersLength; i++) {
          markers[i] = new Marker({
            position: coordinates[i],
            map,
            draggable: false,
            clickable: true,
            flat: false
          });

          $(
            '<div id="location-tooltip-' +
              i +
              '" class="location-tooltip"><span class="name">' +
              locationName[i] +
              '</span><br /><span class="address">' +
              address[i] +
              '</span></div>'
          ).appendTo(container);

          // hide or display tooltip
          event.addListener(markers[i], 'click', () => {
            const tooltip = $('#location-tooltip-' + i);

            if (tooltip.css('display') !== 'block') {
              let position = map
                .getProjection()
                .fromLatLngToPoint(coordinates[i]);
              const topRight = map
                .getProjection()
                .fromLatLngToPoint(map.getBounds().getNorthEast());
              const bottomLeft = map
                .getProjection()
                .fromLatLngToPoint(map.getBounds().getSouthWest());
              const scale = Math.pow(2, map.getZoom());

              tooltip.show();
              position = new Point(
                (position.x - bottomLeft.x) * scale,
                (position.y - topRight.y) * scale
              );

              const widthName = $(
                '#location-tooltip-' + i + ' span.name'
              ).textWidth();
              const widthAddress = $(
                '#location-tooltip-' + i + ' span.address'
              ).textWidth();
              const longerWidth =
                (widthName > widthAddress ? widthName : widthAddress) + 2;

              tooltip.hide();
              tooltip.css('width', longerWidth + 'px');
              tooltip.css(
                'left',
                parseInt(position.x) - parseInt(tooltip.css('width')) / 2 + 'px'
              );
              tooltip.css('top', parseInt(position.y) + 5 + 'px');
              tooltip.css('z-index', markerZIndex++);
              tooltip.fadeIn(300);
            } else {
              tooltip.fadeOut(300);
            }
          });
        }

        if (markersLength > 1) {
          const bounds = new LatLngBounds();
          for (let i = 0; i < markersLength; i++) {
            bounds.extend(coordinates[i]);
          }

          map.fitBounds(bounds);
        }
      });
    }
  });
})(jQuery);
